import { apiClient } from './client';

export type InstrumentSuggestion = {
    name: string | null;
    reference: string | null;
    /** Where the reference came from. `none` means there is nothing to show. */
    source: 'satepsi' | 'model' | 'none';
    satepsi_test_id?: string;
};

export type InstrumentSuggestionResponse = {
    data: InstrumentSuggestion;
};

/**
 * The table's shape, and never its numbers: the caption, the column headers and
 * the labels of the first column. See `docs/ai/instrument-suggestions.md` in the
 * api for why the cells stay in the browser.
 */
export type InstrumentSuggestionPayload = {
    title_hint?: string;
    header: string[];
    row_labels: string[];
    printed_name?: string;
    patient_id?: string;
};

export const instrumentSuggestionsApi = {
    suggest: async (
        payload: InstrumentSuggestionPayload,
        signal?: AbortSignal,
    ): Promise<InstrumentSuggestionResponse> => {
        // The response interceptor in `client.ts` already unwraps `response.data`,
        // so axios' own types are wrong here — same cast every module makes.
        const response = await apiClient.post<InstrumentSuggestionResponse>(
            '/instruments/suggest',
            payload,
            { signal },
        );

        return response as unknown as InstrumentSuggestionResponse;
    },
};
